import {
  ItemStockUnitParams,
  ItemStockUnitResponse,
  CreateItemStockUnitFormType,
  CreateItemStockUnitResponse,
  DeleteItemStockUnitRequestBody,
  DeleteItemStockUnitResponse,
  EditItemStockUnitFormType,
  EditItemStockUnitResponse,
} from "src/pages/MasterData/ItemStockUnit/api/interfaces";
import { getPagination } from "src/utils/getPagination";
import API from ".";

const featureApiRoute = "/item-stock-units";

export const getItemStockUnit = async ({
  limit,
  offset,
  unitStockName,
}: ItemStockUnitParams): Promise<ItemStockUnitResponse> => {
  const paginationParam = getPagination({ limit, offset });

  const response = await API.get<ItemStockUnitResponse>(featureApiRoute, {
    params: {
      ...paginationParam,
      ...(unitStockName ? { name: unitStockName } : {}),
    },
  });

  return response.data;
};

export const createItemStockUnit = async (
  form: CreateItemStockUnitFormType
): Promise<CreateItemStockUnitResponse> => {
  const requestBody = {
    name: form.name,
    description: form.description,
  };

  const response = await API.post<CreateItemStockUnitResponse>(
    featureApiRoute,
    requestBody
  );

  return response.data;
};

export const editItemStockUnit = async ({
  id,
  ...form
}: EditItemStockUnitFormType): Promise<EditItemStockUnitResponse> => {
  const requestBody = {
    name: form.name,
    description: form.description,
  };

  const response = await API.put<EditItemStockUnitResponse>(
    `${featureApiRoute}/${id}`,
    requestBody
  );

  return response.data;
};

export const deleteItemStockUnit = async ({
  id,
}: DeleteItemStockUnitRequestBody): Promise<DeleteItemStockUnitResponse> => {
  const response = await API.delete<DeleteItemStockUnitResponse>(
    `${featureApiRoute}/${id}`
  );

  return response.data;
};
